import React, { useEffect, useState } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  IconButton,
  Menu,
  TextField,
  Typography,
  Grid,
  Checkbox
} from '@material-ui/core';
import {
  DeleteRounded,
  AddCircle,
  MoreVertRounded,
  CreateRounded
} from '@material-ui/icons';
import InlineTable from '@/module/common/component/InlineTable';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import AutocompleteModal from '@/module/common/component/AutocompleteModal';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import { profileColumn } from '../constants';
import { TableWrapped } from '@/module/company/component/CompanyPaper/styled';
import servicesDispatcher from '@/module/services/action';
import globalDispatcher from '@/redux/global/actions';
import styled from 'styled-components';
import MenuAction from '@/components/MenuAction';
import ProfileDetailModal from './ProfileDetailModal';
import { findIndex, isEmpty } from 'lodash';

const ProfileInformation = ({
  errors,
  setErrors,
  formValue,
  setFormValue,
  disabled
}) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [showDetailModal, setShowDetailModal] = useState(false);

  const [numberSelected, setNumberSelected] = useState(0);
  const [localData, setLocalData] = useState([]);
  const [mandatoryData, setMandatoryData] = useState([]);

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onAddNewTest = data => {
    const mandatory = data.filter(item => item.isRequired);

    const newMandatoryData = mandatory.map(item => ({
      ...item,
      isRequired: true
    }));

    const unMandatoryData = data.filter(item => !item.isRequired);
    const newUnMandatoryData = unMandatoryData.map(item => ({
      ...item,
      isRequired: false
    }));

    const lstMandatory = mandatoryData.concat(newMandatoryData);
    const lsUntMandatory = localData.concat(newUnMandatoryData);

    let lstProfiles = [...lsUntMandatory, ...lstMandatory];
    setMandatoryData(lstMandatory);
    setLocalData(lsUntMandatory);
    setFormValue({ ...formValue, lstProfiles });
    setShowModal(false);
  };

  const onDeleteTest = (index, isRequired) => {
    let newMandatoryData = [...mandatoryData];
    let newLocalData = [...localData];
    if (isRequired) {
      newMandatoryData.splice(index, 1);
      setMandatoryData(newMandatoryData);
    } else {
      newLocalData.splice(index, 1);
      setLocalData(newLocalData);
    }

    let lstProfiles = [...newMandatoryData, ...newLocalData];

    if (isEmpty(newLocalData)) {
      setFormValue({
        ...formValue,
        lstProfiles,
        totalMandatoryProfile: 0
      });
      setNumberSelected(0);
    } else setFormValue({ ...formValue, lstProfiles });
  };

  const updateCheckedData = (dataUpdated = [], testExists = []) => {
    const newDataLocal = [...dataUpdated];

    testExists.forEach(test => {
      const indexProject = findIndex(dataUpdated, it => it.id === test.id);

      if (indexProject < 0) return;
      const updatedProject = newDataLocal[indexProject];

      const indexTestChange = findIndex(
        newDataLocal,
        it => it.id === updatedProject.id
      );
      if (indexTestChange < 0) return;
      newDataLocal[indexTestChange] = { ...test };
    });

    return newDataLocal;
  };
  const onChangeValueCheckbox = (value, row) => {
    const newData = { ...row, isRequired: value };
    const dataLocalUpdated = updateCheckedData(formValue.lstProfiles, [
      newData
    ]);
    const newListMandatory = [...dataLocalUpdated].filter(
      item => item.isRequired
    );
    const newListUnMandatory = [...dataLocalUpdated].filter(
      item => !item.isRequired
    );

    if (isEmpty(newListUnMandatory)) {
      setFormValue({
        ...formValue,
        lstProfiles: dataLocalUpdated,
        totalMandatoryProfile: 0
      });
      setNumberSelected(0);
    } else setFormValue({ ...formValue, lstProfiles: dataLocalUpdated });
    setLocalData(newListUnMandatory);
    setMandatoryData(newListMandatory);
  };

  const onChangeValueRequired = e => {
    const value = e.target.value;

    setNumberSelected(value);
    setFormValue({ ...formValue, totalMandatoryProfile: Number(value) });
  };

  const listActions = [
    {
      key: 'edit',
      icon: CreateRounded,
      label: 'View detail',
      onClick: () => {
        setAnchorEl(null);
        setShowDetailModal(true);
      }
    },
    {
      key: 'delete',
      icon: DeleteRounded,
      label: 'Delete',
      onClick: () => {
        setAnchorEl(null);
        onDeleteTest(selectedItem.itemIdx, selectedItem.isRequired);
      }
    }
  ];

  useEffect(() => {
    if (!isEmpty(formValue.lstProfiles)) {
      const mandatory = formValue.lstProfiles.filter(item => item.isRequired);

      const unMandatoryData = formValue.lstProfiles.filter(
        item => !item.isRequired
      );

      setMandatoryData(mandatory);
      setLocalData(unMandatoryData);
      setNumberSelected(formValue.totalMandatoryProfile);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (setErrors)
      if (numberSelected > localData.length)
        setErrors({
          ...errors,
          numberSelected: `Please choose number no more than total profiles (${localData.length})`
        });
      else setErrors({});

    // eslint-disable-next-line
  }, [localData, numberSelected]);

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows
      }}
      {...props}
    />
  );
  const TableHeader = () => (
    <TableHead>
      {!disabled && !showModal && !isEmpty(localData) && (
        <TableRow>
          <TableCell colspan={profileColumn.length}>
            <Typography
              variant="h6"
              component="span"
              style={{ fontWeight: 'bold' }}
            >
              Mandatory
            </Typography>
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        {profileColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{ width: item?.width }}
            />
          ) : (
            <TableCell
              key={item.stateValue}
              style={{ width: item?.width }}
            ></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const TableHeaderForIsRequired = () => (
    <TableHead>
      <TableRow>
        <TableCell colspan={profileColumn.length}>
          <Grid container direction="row" alignItems="center">
            <Typography
              variant="h6"
              component="span"
              style={{ fontWeight: 'bold' }}
            >
              Optional, choose
            </Typography>
            <TextField
              autoFocus
              type="number"
              value={numberSelected}
              onChange={onChangeValueRequired}
              error={errors.numberSelected}
              helperText={errors.numberSelected}
            />
            <Typography
              variant="h6"
              component="span"
              style={{ fontWeight: 'bold' }}
            >
              from:
            </Typography>
          </Grid>
        </TableCell>
      </TableRow>
      <TableRow>
        {profileColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{ width: item?.width }}
            />
          ) : (
            <TableCell
              key={item.stateValue}
              style={{ width: item?.width }}
            ></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const TableFooter = () =>
    disabled ? null : (
      <StyledButtonEnhance
        background="#EFDFEB"
        color="#AD5E99"
        backgroundHover="#EFDFEB"
        onClick={() => setShowModal(true)}
      >
        <div className="add-group">
          <span>Add new profile</span>
          <AddCircle />
        </div>
      </StyledButtonEnhance>
    );

  const renderRow = isRequired => (row, i) => (
    <>
      <TableCell>{!hiddenRows.name && row.name}</TableCell>
      <TableCell>{!hiddenRows.code && row.code}</TableCell>
      <TableCell>{!hiddenRows.totalTests && row.totalTests}</TableCell>
      <TableCell>{!hiddenRows.totalProfiles && row.totalProfiles}</TableCell>
      {!disabled && !showModal ? (
        <TableCell>
          <Checkbox
            checked={row.isRequired}
            color="primary"
            onChange={e => onChangeValueCheckbox(e.target.checked, row)}
          />
        </TableCell>
      ) : (
        <TableCell></TableCell>
      )}
      <TableCell align="right">
        {!disabled && (
          <IconButton
            onClick={e => {
              setSelectedItem({
                ...row,
                itemIdx: i,
                isRequired
              });
              setAnchorEl(e.currentTarget);
            }}
          >
            <MoreVertRounded />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  const renderOnModalRow = onDeleteTest => (row, i, onDeleteValue) => (
    <>
      <TableCell>{!hiddenRows.name && row.name}</TableCell>
      <TableCell>{!hiddenRows.code && row.code}</TableCell>
      <TableCell>{!hiddenRows.totalTests && row.totalTests}</TableCell>
      <TableCell>{!hiddenRows.totalProfiles && row.totalProfiles}</TableCell>
      <TableCell align="right">
        <IconButton
          className="delete-icon"
          onClick={() => (onDeleteTest ? onDeleteTest(i) : onDeleteValue(i))}
        >
          <DeleteRounded />
        </IconButton>
      </TableCell>
    </>
  );

  return (
    <TableWrapped>
      {disabled ? (
        <InlineTable
          Header={TableHeader}
          data={formValue.lstOldProfiles}
          Footer={TableFooter}
          noDataHelperText={
            disabled
              ? 'No data'
              : 'Click button "Add new profile" to create new one'
          }
          renderRow={renderRow()}
        />
      ) : (
        <>
          <InlineTable
            Header={TableHeader}
            data={mandatoryData}
            Footer={TableFooter}
            noDataHelperText="Select checkbox list below to create new one"
            renderRow={renderRow(true)}
          />
          {!isEmpty(localData) && (
            <InlineTable
              Header={TableHeaderForIsRequired}
              data={localData}
              renderRow={renderRow()}
            />
          )}
        </>
      )}

      <Dialog
        maxWidth="lg"
        open={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        disableEnforceFocus
      >
        <ProfileDetailModal
          selectedProfile={selectedItem}
          onClose={() => setShowDetailModal(false)}
        />
      </Dialog>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuAction listActions={listActions} />
      </Menu>

      <Dialog maxWidth="lg" open={showModal} onClose={onCloseModal}>
        <AutocompleteModal
          onClose={onCloseModal}
          title="Profiles"
          optionLabel="name"
          textFieldPlaceholder="Select profile"
          onSubmit={onAddNewTest}
          Header={TableHeader}
          renderRow={renderOnModalRow()}
          getListOptions={globalDispatcher.getListProfiles}
          existedOption={formValue.lstProfiles}
        />
      </Dialog>
    </TableWrapped>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  display: flex;
  justify-content: center;
  max-width: 200px;
  float: right;
  margin-top: 15px;
  height: 35px;
  padding: 8px 16px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
    }
  }
`;

export default ProfileInformation;
